import { render, staticRenderFns } from "./AutomationWizardOverviewBenefits.vue?vue&type=template&id=1429095e&"
import script from "./AutomationWizardOverviewBenefits.vue?vue&type=script&lang=js&"
export * from "./AutomationWizardOverviewBenefits.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports